import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { SearchIcon } from '@common/components/icons';
import * as styles from '../EntityPanelSelector.module.css';

/**
 * PanelSearch Component
 * Renders a search input with search icon
 */
function PanelSearch({ value, onChange, disabled }) {
  const { t } = useTranslation();
  
  return (
    <div className={styles.searchWrapper}>
      <SearchIcon />
      <input
        type="search"
        className={styles.searchInput}
        placeholder={t('common.search')}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
      />
    </div>
  );
}

PanelSearch.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

PanelSearch.defaultProps = {
  disabled: false,
};

export default PanelSearch;

